// extracted by mini-css-extract-plugin
export default {"description":"style_description__7ODUz","fade-in":"style_fade-in__qPepL","top":"style_top__RolKx","image":"style_image__RQHm4"};